module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUNJREFUeNpc0s0rRGEUx3H3zrhZ2IgMNRuJmo28rGxnp9Q0ljaEPQtW/gt2Sv4CJgvZWIhSLMZOxB1uShhvIZvB9T38rp7mqc/innvOeZ7n9HhxHDc4K4sJjKIbHiJsYw2V/0wrlDFcx3/rCYc4wJ1iVUwl+UlRETV8YBZZp2FGBY9qMJ0UduIGb8g7BasoOd9DuMczchZYVKc5J8kcIULKiY0rdzlJsC4ddYV7OKmLNaGC0LPtmVGIYU2uF1/oQyPK8FFFESXk0wp+a8gtyOATAVJod3I8Nf0dzrFG3QpPd/KxjzMETixQLLJOW2hDwfqoo3VP66g1Jzaiq+zYjl3a8QGDziDWsatT2HcPLvGOgSRpUmO+1cibVeBrkgVcKGfBfTlmBi/6GWITGzhVzF7VfP2TS+SwhHO8yhVW0O/m/ggwAP00+wMwLIUsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/+.png
// module id = iV+3
// module chunks = 18